import type { Percentages } from 'lumen/utils/constants/pi-constant-values';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const transformIntoPercentage = (absolute: number, total: number) => {
  let relative = 0;

  if (total > 0) {
    relative = absolute / total;
  }

  return relative;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function calculateParityAnalyticsValues(
  segmentationValueObject: Percentages,
  overridingTotal: number | undefined = undefined,
) {
  // The provided value object can be empty (new-history) and must therefore be safely handled
  if (!segmentationValueObject) {
    return {
      win: 0,
      meet: 0,
      loss: 0,
      totalNbOfShops: 0,
    };
  }

  const { win, meet, loss } = segmentationValueObject;
  const total = overridingTotal ?? win + meet + loss;

  // We fill up percentages, the loss is always the rest (prevents %'s not adding up to 100%)
  const percentages = {
    win: transformIntoPercentage(win, total),
    meet: transformIntoPercentage(meet, total),
    loss: 0, // Will be calculated later
    totalNbOfShops: total,
  };

  // Clamp loss to a minimum value of 0
  // Do not clamp when overriding the total
  if (!overridingTotal) {
    if (1 - (percentages.win + percentages.meet) < 0 || loss === 0) {
      percentages.loss = 0;
    } else {
      percentages.loss = 1 - (percentages.win + percentages.meet);
    }
  } else {
    // Treat loss like the win and meet
    percentages.loss = transformIntoPercentage(loss, total);
  }

  return percentages;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function calculateBenchmarkPercentages(
  benchmarkObject: Percentages | undefined,
) {
  // The provided value object can be empty (new-history) and must therefore be safely handled
  if (!benchmarkObject) {
    return {
      win: 0,
      meet: 0,
      loss: 0,
      totalNbOfShops: 0,
    };
  }

  const { win, meet, loss } = benchmarkObject;
  const total = win + meet + loss;

  // We fill up percentages, the loss is always the rest (prevents %'s not adding up to 100%)
  const percentages = {
    win: transformIntoPercentage(win, total),
    meet: transformIntoPercentage(meet, total),
    loss: 0, // Will be calculated later
    totalNbOfShops: total,
  };

  // Clamp loss to a minimum value of 0
  if (1 - (percentages.win + percentages.meet) < 0 || loss === 0) {
    percentages.loss = 0;
  } else {
    percentages.loss = 1 - (percentages.win + percentages.meet);
  }

  return percentages;
}
